// packages/web/src/components/admin/email-templates/reset-confirm-dialog.tsx
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useDeleteEmailTemplate } from "@/api/email-templates/mutations";

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  templateKey: string;
  locale: string;
  onReset: () => void;
}

export function ResetConfirmDialog({ open, onOpenChange, templateKey, locale, onReset }: Props) {
  const del = useDeleteEmailTemplate();

  async function handleReset() {
    try {
      await del.mutateAsync({ key: templateKey, locale });
      onReset();
      onOpenChange(false);
    } catch (err) {
      toast.error((err as Error).message);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Terugzetten op standaard?</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-ink-700">
          Je verwijdert de aangepaste tekst voor <code className="font-mono">{templateKey}</code> in{" "}
          {locale.toUpperCase()}. De code-defaults worden weer actief. Deze actie is niet ongedaan
          te maken.
        </p>
        <DialogFooter>
          {/* Annuleren is the PRIMARY (safe) action per destructive-confirm convention */}
          <Button type="button" variant="primary" onClick={() => onOpenChange(false)} autoFocus>
            Annuleren
          </Button>
          <Button
            type="button"
            variant="danger-soft"
            onClick={handleReset}
            disabled={del.isPending}
          >
            Terugzetten
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
